'use client'

import { useEffect, type RefObject } from 'react'

import { usePathname } from 'next/navigation'

import { trackHubLink } from './hub-analytics'
import { observeHubSections } from './observe-hub-sections'

export const useHubAnalytics = (ref: RefObject<HTMLDivElement | null>) => {
  const pathname = usePathname()
  useEffect(() => {
    const root = ref.current
    if (!root) {
      return
    }
    const stop = observeHubSections(root)
    root.addEventListener('click', trackHubLink)
    root.addEventListener('auxclick', trackHubLink)
    return () => {
      stop()
      root.removeEventListener('click', trackHubLink)
      root.removeEventListener('auxclick', trackHubLink)
    }
  }, [ref, pathname])
}
